import React from 'react';
import { connect } from 'react-redux';
import { default as UI_ACTIONS } from '../../reducers/ui';
import { default as API } from '../../api';
import { default as SESSION_ACTIONS } from '../../reducers/session';
import { default as __ } from '../../utils';
import Sidebar from '../../components/ui/sidebar';
import ActionBar from './action-bar';

import Game from './builder';
import './styles.css';

const ConnectedCreate = props => {
  const post = state => {
    const { notifyUser, sessionId, sessionLevel, addToStore } = props;
    const { duration, players, win, pala, mvp } = state;
    let today = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();

    let courtSide = __.unwrapIterable(players.filter(player => player.you))
      .position;

    API.createDocument(
      {
        duration,
        players,
        victory: win,
        updated: today,
        month: Number(month) + 1,
        year,
        level: sessionLevel,
        pala,
        mvp,
        courtSide,
      },
      sessionId,
    )
      .then(response => {
        __.callAll(
          addToStore({
            duration,
            players,
            victory: win,
            updated: today,
            month,
            year,
            mvp,
            courtSide,
          }),
          notifyUser('', 'sticky', 'success'),
        );
      })
      .catch(o_O => notifyUser(o_O.code, 'sticky', 'fail'));
  };

  return (
    <Game.Container>
      <Sidebar>
        <ActionBar />
      </Sidebar>
      <Game.Court cb={v => post(v)} />
    </Game.Container>
  );
};

const select = state => {
  return {
    sessionLevel: state.session.user.level,
    sessionId: state.session.user.sessionId,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addToStore: game => dispatch(SESSION_ACTIONS.addGame(game)),
    notifyUser: (msg, sticky, icon) =>
      dispatch(UI_ACTIONS.showFeedback(msg, sticky, icon)),
  };
};

const Create = connect(select, mapDispatchToProps)(ConnectedCreate);

export default Create;
